import { useState } from "react";

import useDialog from "@datanac/datanac-mui-toolkit/dist/hooks/useDialog";
import { Add } from "@mui/icons-material";
import { Box, Dialog } from "@mui/material";
import { FinancialIcon } from "components/Icons/Icons";
import { ButtonLargeSquare } from "mui-toolkit/ButtonLargeSquare";
import { v4 } from "uuid";

import { FinancialStatementSchedule_Accounts_Edit } from "./FinancialStatementSchedule_Accounts_EditDialog";
import ScheduleCard from "./ScheduleCard";
import { schedule_financial_statement_accounts_payable } from "./useFinancialStatementSchedule";

export const FinancialStatementSchedule_Accounts_Payable_View = ({ year, onChange, accounts, is_lender }) => {
  const CATEGORY = schedule_financial_statement_accounts_payable;
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const handleChange = async (account) => {
    if (!account.id) {
      account.id = v4();
    }
    if (!account.year && year) {
      account.year = year;
    }
    if (!account.category) {
      account.category = CATEGORY;
    }

    onChange && onChange(account);
  };

  const handleDeleteOnClick = (account) => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...account };
        _newState.is_active = false;
        handleChange(_newState);

        return false;
      },
    });
  };

  // ---

  const [editingItem, setEditingItem] = useState(null);

  // ---

  return (
    <>
      <Box className="cardContainer">
        {(accounts || [])
          ?.filter((item) => item.is_active != false)
          ?.map((item, index) => (
            <ScheduleCard
              key={index}
              Avatar={FinancialIcon}
              item={item}
              handleDeleteOnClick={handleDeleteOnClick}
              handleCardOnClick={() => setEditingItem(item)}
            />
          ))}

        <ButtonLargeSquare icon={<Add />} title={"Add New"} onClick={() => setEditingItem({})} />
      </Box>

      <Dialog open={Boolean(editingItem != null)}>
        <FinancialStatementSchedule_Accounts_Edit
          onChange={handleChange}
          onClose={() => setEditingItem(null)}
          account={editingItem}
          is_lender={is_lender}
        />
      </Dialog>

      {confirmDialogComponent}
    </>
  );
};
